import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

import { GanttColumnTypesEnum } from 'src/pages/gantt/gantt.constants';

const {
  primary: { white },
  tone: { twilightBlue, markYellow },
  grayVariations: { athensGray },
} = PLATFORM_THEME_COLORS;

const getActiveWorkingHours = (workingHours: any, date: Date) => {
  const [baseConfig, ...restConfigs] = workingHours;

  if (!restConfigs.length) return baseConfig;

  const config = restConfigs.reverse().find((conf: any) => new Date(conf.startFrom) < date);

  if (config) return config;

  return baseConfig;
};

export const getRowStatusColor = (types: GanttColumnTypesEnum[], colorSchema: any) => {
  const isCurrentDay = types.includes(GanttColumnTypesEnum.CURRENT_DAY);

  if (isCurrentDay) return colorSchema?.todayColor || twilightBlue;

  const isHoliday = types.includes(GanttColumnTypesEnum.HOLYDAY);

  if (isHoliday) return colorSchema?.holidayColor || markYellow;

  const isWeekend = types.includes(GanttColumnTypesEnum.WEEKEND);

  if (isWeekend) return colorSchema?.weekendColor || athensGray;

  return white;
};

export const checkIfHaveWorkingHours = (workingHours: any[], date: Date, weekDay: string) => {
  if (!workingHours.length) return false;

  const workingHoursByWeek = getActiveWorkingHours(Array.from(workingHours).reverse(), date);

  const workingHoursByWeekDay = workingHoursByWeek[weekDay];

  if (!workingHoursByWeekDay) return false;

  const { to, from } = workingHoursByWeekDay;

  return new Date(to) > new Date(from);
};
